let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("h7dGJ")).then(() => parcelRequire('abQPO'));